import React from 'react';
import MetaData from '../layout/MetaData';
import { Link } from 'react-router-dom';

const NotFound = () => (
  <>
    <MetaData title="Page Not Found" />
    <div className="row wrapper">
      <div className="col-10 col-lg-6 text-center">
        <div className="card p-5">
          <h1 className="display-1 fw-bold text-primary mb-4">404</h1>
          <h3 className="mb-3">Page Not Found</h3>
          <p className="text-muted mb-4">The page you're looking for doesn't exist or has been moved.</p>
          <Link to="/" className="btn btn-primary py-2 px-4 fw-semibold">
            Go to Home
          </Link>
        </div>
      </div>
    </div>
  </>
);

export default NotFound;